import { render, staticRenderFns } from "./emailColumnEditor.vue?vue&type=template&id=21822ad6&scoped=true&"
import script from "./emailColumnEditor.vue?vue&type=script&lang=js&"
export * from "./emailColumnEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21822ad6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VHover,VSheet})
